import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { plainToClass } from 'class-transformer';

import { environment } from '../../../environments/environment';
import { ProgressIndicatorService } from './progress-indicator.service';
import { CollectApiServiceBase } from './collect-api-base.service';
import { Milestone } from '../models/milestones/milestone.model';
import { DataCollectionMilestone } from '../models/milestones/data-collection-milestone.model';
import { SiteMilestonesSummary } from '../models/milestones/site-milestones-summary.model';

@Injectable()
export class MilestoneService extends CollectApiServiceBase<Milestone> {
    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'milestone', DataCollectionMilestone)
    }

    // Overrides.
    // None at this time.

    // Service methods.
    // Site/data collection milestone-related methods.
    // Finder methods.
    public getSiteMilestones(dataCollectionId: number): Promise<DataCollectionMilestone[]> {
        let url = `${this.url}/${this.endpoint}/getSiteMilestones/${dataCollectionId}`;

        //this.updateProgress(50, 75, `Getting site milestones ...`);

        return this.http.get<DataCollectionMilestone[]>(url)
            .toPromise()
            .then(response => {
                let milestones: DataCollectionMilestone[] = [];

                if (response != null) {
                    for (let iMilestone: number = 0; iMilestone < response.length; iMilestone++) {
                        let oMilestone = response[iMilestone];
                        let milestone: DataCollectionMilestone = plainToClass(DataCollectionMilestone, oMilestone);

                        milestones.push(milestone);
                    }
                }

                //this.updateProgress(100, 100, `Completed`);

                return (milestones);
            })
            .catch(this.handleError);
    }

    public getSiteMilestonesSummary(dataCollectionId: number): Promise<SiteMilestonesSummary> {
        let url = `${this.url}/${this.endpoint}/getSiteMilestonesSummary/${dataCollectionId}`;

        //this.updateProgress(50, 75, `Getting site milestones ...`);

        return this.http.get<SiteMilestonesSummary>(url)
            .toPromise()
            .then(response => {
                let summary: SiteMilestonesSummary = null;

                if (response != null) {
                    summary = plainToClass(SiteMilestonesSummary, response);
                }

                //this.updateProgress(100, 100, `Completed`);

                return (summary);
            })
            .catch(this.handleError);
    }

    public findSiteMilestone(milestoneId: number): Promise<DataCollectionMilestone> {
        let url = `${this.url}/${this.endpoint}/findSiteMilestones/${milestoneId}`;

        //this.updateProgress(50, 75, `Getting site milestones ...`);

        return this.http.get<DataCollectionMilestone>(url)
            .toPromise()
            .then(response => {
                let milestone: DataCollectionMilestone = null;

                if (response != null) {
                    milestone = plainToClass(DataCollectionMilestone, response);
                }

                //this.updateProgress(100, 100, `Completed`);

                return (milestone);
            })
            .catch(this.handleError);
    }

    // Create, update, delete methods.
    public createSiteMilestone(milestone: DataCollectionMilestone): Promise<DataCollectionMilestone> {
        let url = `${this.url}/${this.endpoint}/createSiteMilestone`;

        this.updateProgress(50, 75, `Creating site milestone ...`);

        return this.http.post<DataCollectionMilestone>(url, milestone)
            .toPromise()
            .then(response => {
                let obj: DataCollectionMilestone = plainToClass(DataCollectionMilestone, response);

                this.updateProgress(100, 100, `Created the site milestone`);

                return obj;
            })
            .catch(this.handleError);
    }

    public updateSiteMilestone(milestone: DataCollectionMilestone): Promise<DataCollectionMilestone> {
        let url = `${this.url}/${this.endpoint}/updateSiteMilestone`;

        this.updateProgress(50, 75, `Updating site milestone ...`);

        return this.http.put<DataCollectionMilestone>(url, milestone)
            .toPromise()
            .then(response => {
                let obj: DataCollectionMilestone = plainToClass(DataCollectionMilestone, response);

                this.updateProgress(100, 100, `Updated the site milestone`);

                return obj;
            })
            .catch(this.handleError);
    }

    public deleteSiteMilestone(siteMilestoneId: number): Promise<boolean> {
        let url = `${this.url}/${this.endpoint}/deleteSiteMilestone/${siteMilestoneId}`;

        this.updateProgress(50, 75, `Deleting site milestones ...`);

        return this.http.delete<boolean>(url)
            .toPromise()
            .then(response => {
                let bResult: boolean = false;

                if (response != null) {
                    bResult = response;
                }

                this.updateProgress(100, 100, (bResult ? 'Deleted' : 'Delete failed'));

                return (bResult);
            })
            .catch(this.handleError);
    }
}
